export default __webpack_public_path__ + "static/media/alert.8b54a26a.svg";